const attrs = {
  name: "",
  updated_at: "",
  query_map_id: "",
  field_values: {}
};

const options = {
  parentType: "campaigns",
  parentKey: "campaign_id"
};

const getters = {
  setsByCampaign: state => campaignId => {
    return state.content.filter(entry => entry.campaign_id === campaignId);
  }
};

export default {
  generic: {
    attrs,
    options
  },
  getters
};
